import { render, staticRenderFns } from "./ProcessWrapperTemplate.vue?vue&type=template&id=745c00fa&scoped=true&"
import script from "./ProcessWrapperTemplate.vue?vue&type=script&lang=js&"
export * from "./ProcessWrapperTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c00fa",
  null
  
)

export default component.exports